import React from "react";
import NameField from "./NameField";
import StudyField from "./StudyField";
import AdmNoField from "./AdmNoField";
import SchoolField from "./SchoolField";
import CommunicationField from "./CommunicationField";

function FormSection({ formData, handleChange, disabled, errors, validate }) {

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.name1.trim()) {
      newErrors.name1 = "Student name is required";
    }
    if (!formData.study1.trim()) {
      newErrors.study1 = "Study is required";
    }
    if (!formData.AdmNo1.trim()) {
      newErrors.AdmNo1 = "Admission number is required";
    }
    if (!formData.School1.trim()) {
      newErrors.School1 = "School name is required";
    }
    if (!formData.comm.trim()) {
      newErrors.comm = "QR Text is required";
    }

    validate(newErrors);

    if (Object.keys(newErrors).length === 0) {
      console.log("Form submitted successfully");
    }
  };

  return (
    // 🔥 FIXED: form ➝ div (solves nested form warning)
    <div onSubmit={handleSubmit}>
      <NameField
        value={formData}
        onChange={handleChange}
        disabled={disabled}
        error={errors.name1}
      />

      <StudyField
        value={formData}
        onChange={handleChange}
        error={errors.study1}
      />

      <AdmNoField
        value={formData}
        onChange={handleChange}
        error={errors.AdmNo1}
      />

      <SchoolField
        value={formData}
        onChange={handleChange}
        error={errors.School1}
      />

      <CommunicationField
        value={formData}
        onChange={handleChange}
        error={errors.comm}
      />
    </div>
  );
}

export default FormSection;
